import { Country } from '@shared/sf-form-controls/sf-country-selector/sf-country-selector/country-selector.model';
export const findSelectedCountryByIso = (iso: string): Country => {
	return countryList.find((country) => country.iso === iso);
};

export const countryList: Country[] = [
	{ en: 'Afghanistan', pl: 'Afganistan', iso: 'AF', countryCode: 93 },
	{ en: 'Albania', pl: 'Albania', iso: 'AL', countryCode: 355 },
	{ en: 'Algeria', pl: 'Algieria', iso: 'DZ', countryCode: 213 },
	{ en: 'Poland', pl: 'Polska', iso: 'PL', countryCode: 48 },
	{ en: 'Andorra', pl: 'Andora', iso: 'AD', countryCode: 376 },
	{ en: 'Angola', pl: 'Angola', iso: 'AO', countryCode: 244 },
	{ en: 'Antigua and Barbuda', pl: 'Antigua i Barbuda', iso: 'AG', countryCode: 1 },
	{ en: 'Argentina', pl: 'Argentyna', iso: 'AR', countryCode: 54 },
	{ en: 'Armenia', pl: 'Armenia', iso: 'AM', countryCode: 374 },
	{ en: 'Australia', pl: 'Australia', iso: 'AU', countryCode: 61 },
	{ en: 'Austria', pl: 'Austria', iso: 'AT', countryCode: 43 },
	{ en: 'Azerbaijan', pl: 'Azerbejdżan', iso: 'AZ', countryCode: 994 },
	{ en: 'The Bahamas', pl: 'Bahamy', iso: 'BS', countryCode: 1 },
	{ en: 'Bahrain', pl: 'Bahrajn', iso: 'BH', countryCode: 973 },
	{ en: 'Bangladesh', pl: 'Bangladesz', iso: 'BD', countryCode: 880 },
	{ en: 'Barbados', pl: 'Barbados', iso: 'BB', countryCode: 1 },
	{ en: 'Belarus', pl: 'Białoruś', iso: 'BY', countryCode: 375 },
	{ en: 'Belgium', pl: 'Belgia', iso: 'BE', countryCode: 32 },
	{ en: 'Belize', pl: 'Belize', iso: 'BZ', countryCode: 501 },
	{ en: 'Benin', pl: 'Benin', iso: 'BJ', countryCode: 229 },
	{ en: 'Bhutan', pl: 'Bhutan', iso: 'BT', countryCode: 975 },
	{ en: 'Bolivia', pl: 'Boliwia', iso: 'BO', countryCode: 591 },
	{ en: 'Bosnia and Herzegovina', pl: 'Bośnia i Hercegowina', iso: 'BA', countryCode: 387 },
	{ en: 'Botswana', pl: 'Botswana', iso: 'BW', countryCode: 267 },
	{ en: 'Brazil', pl: 'Brazylia', iso: 'BR', countryCode: 55 },
	{ en: 'Brunei', pl: 'Brunei', iso: 'BN', countryCode: 673 },
	{ en: 'Bulgaria', pl: 'Bułgaria', iso: 'BG', countryCode: 359 },
	{ en: 'Burkina Faso', pl: 'Burkina Faso', iso: 'BF', countryCode: 226 },
	{ en: 'Burundi', pl: 'Burundi', iso: 'BI', countryCode: 257 },
	{ en: 'Cape Verde', pl: 'Republika Zielonego Przylądka', iso: 'CV', countryCode: 238 },
	{ en: 'Cambodia', pl: 'Kambodża', iso: 'KH', countryCode: 855 },
	{ en: 'Cameroon', pl: 'Kamerun', iso: 'CM', countryCode: 237 },
	{ en: 'Canada', pl: 'Kanada', iso: 'CA', countryCode: 1 },
	{ en: 'Central African Republic', pl: 'Republika Środkowoafrykańska', iso: 'CF', countryCode: 236 },
	{ en: 'Chad', pl: 'Czad', iso: 'TD', countryCode: 235 },
	{ en: 'Chile', pl: 'Chile', iso: 'CL', countryCode: 56 },
	{ en: 'China', pl: 'Chiny', iso: 'CN', countryCode: 86 },
	{ en: 'Colombia', pl: 'Kolumbia', iso: 'CO', countryCode: 57 },
	{ en: 'Comoros', pl: 'Komory', iso: 'KM', countryCode: 269 },
	{ en: 'Democratic Republic of the Congo', pl: 'Demokratyczna Republika Konga', iso: 'CD', countryCode: 243 },
	{ en: 'Republic of the Congo', pl: 'Kongo', iso: 'CG', countryCode: 242 },
	{ en: 'Costa Rica', pl: 'Kostaryka', iso: 'CR', countryCode: 506 },
	{ en: "Côte d'Ivoire", pl: 'Wybrzeże Kości Słoniowej', iso: 'CI', countryCode: 225 },
	{ en: 'Croatia', pl: 'Chorwacja', iso: 'HR', countryCode: 385 },
	{ en: 'Cuba', pl: 'Kuba', iso: 'CU', countryCode: 53 },
	{ en: 'Cyprus', pl: 'Cypr', iso: 'CY', countryCode: 357 },
	{ en: 'Czech Republic', pl: 'Czechy', iso: 'CZ', countryCode: 420 },
	{ en: 'Denmark', pl: 'Dania', iso: 'DK', countryCode: 45 },
	{ en: 'Djibouti', pl: 'Dżibuti', iso: 'DJ', countryCode: 253 },
	{ en: 'Dominica', pl: 'Dominika', iso: 'DM', countryCode: 1 },
	{ en: 'Dominican Republic', pl: 'Dominikana', iso: 'DO', countryCode: 1 },
	{ en: 'East Timor', pl: 'Timor Wschodni', iso: 'TL', countryCode: 670 },
	{ en: 'Ecuador', pl: 'Ekwador', iso: 'EC', countryCode: 593 },
	{ en: 'Egypt', pl: 'Egipt', iso: 'EG', countryCode: 20 },
	{ en: 'El Salvador', pl: 'Salwador', iso: 'SV', countryCode: 503 },
	{ en: 'Equatorial Guinea', pl: 'Gwinea Równikowa', iso: 'GQ', countryCode: 240 },
	{ en: 'Eritrea', pl: 'Erytrea', iso: 'ER', countryCode: 291 },
	{ en: 'Estonia', pl: 'Estonia', iso: 'EE', countryCode: 372 },
	{ en: 'Eswatini', pl: 'Eswatini', iso: 'SZ', countryCode: 268 },
	{ en: 'Ethiopia', pl: 'Etiopia', iso: 'ET', countryCode: 251 },
	{ en: 'Fiji', pl: 'Fidżi', iso: 'FJ', countryCode: 679 },
	{ en: 'Finland', pl: 'Finlandia', iso: 'FI', countryCode: 358 },
	{ en: 'France', pl: 'Francja', iso: 'FR', countryCode: 33 },
	{ en: 'Gabon', pl: 'Gabon', iso: 'GA', countryCode: 241 },
	{ en: 'Gambia', pl: 'Gambia', iso: 'GM', countryCode: 220 },
	{ en: 'Georgia', pl: 'Gruzja', iso: 'GE', countryCode: 995 },
	{ en: 'Germany', pl: 'Niemcy', iso: 'DE', countryCode: 49 },
	{ en: 'Ghana', pl: 'Ghana', iso: 'GH', countryCode: 233 },
	{ en: 'Greece', pl: 'Grecja', iso: 'GR', countryCode: 30 },
	{ en: 'Grenada', pl: 'Grenada', iso: 'GD', countryCode: 1 - 473 },
	{ en: 'Guatemala', pl: 'Gwatemala', iso: 'GT', countryCode: 502 },
	{ en: 'Guinea', pl: 'Gwinea', iso: 'GN', countryCode: 224 },
	{ en: 'Guinea-Bissau', pl: 'Gwinea Bissau', iso: 'GW', countryCode: 245 },
	{ en: 'Guyana', pl: 'Gujana', iso: 'GY', countryCode: 592 },
	{ en: 'Haiti', pl: 'Haiti', iso: 'HT', countryCode: 509 },
	{ en: 'Honduras', pl: 'Honduras', iso: 'HN', countryCode: 504 },
	{ en: 'Hungary', pl: 'Węgry', iso: 'HU', countryCode: 36 },
	{ en: 'Iceland', pl: 'Islandia', iso: 'IS', countryCode: 354 },
	{ en: 'India', pl: 'Indie', iso: 'IN', countryCode: 91 },
	{ en: 'Indonesia', pl: 'Indonezja', iso: 'ID', countryCode: 62 },
	{ en: 'Iran', pl: 'Iran', iso: 'IR', countryCode: 98 },
	{ en: 'Iraq', pl: 'Irak', iso: 'IQ', countryCode: 964 },
	{ en: 'Ireland', pl: 'Irlandia', iso: 'IE', countryCode: 353 },
	{ en: 'Israel', pl: 'Izrael', iso: 'IL', countryCode: 972 },
	{ en: 'Italy', pl: 'Włochy', iso: 'IT', countryCode: 39 },
	{ en: 'Jamaica', pl: 'Jamajka', iso: 'JM', countryCode: 1 - 876 },
	{ en: 'Japan', pl: 'Japonia', iso: 'JP', countryCode: 81 },
	{ en: 'Jordan', pl: 'Jordania', iso: 'JO', countryCode: 962 },
	{ en: 'Kazakhstan', pl: 'Kazachstan', iso: 'KZ', countryCode: 7 },
	{ en: 'Kenya', pl: 'Kenia', iso: 'KE', countryCode: 254 },
	{ en: 'Kiribati', pl: 'Kiribati', iso: 'KI', countryCode: 686 },
	{ en: 'North Korea', pl: 'Korea Północna', iso: 'KP', countryCode: 850 },
	{ en: 'South Korea', pl: 'Korea Południowa', iso: 'KR', countryCode: 82 },
	{ en: 'Kuwait', pl: 'Kuwejt', iso: 'KW', countryCode: 965 },
	{ en: 'Kyrgyzstan', pl: 'Kirgistan', iso: 'KG', countryCode: 996 },
	{ en: 'Laos', pl: 'Laos', iso: 'LA', countryCode: 856 },
	{ en: 'Latvia', pl: 'Łotwa', iso: 'LV', countryCode: 371 },
	{ en: 'Lebanon', pl: 'Liban', iso: 'LB', countryCode: 961 },
	{ en: 'Lesotho', pl: 'Lesoto', iso: 'LS', countryCode: 266 },
	{ en: 'Liberia', pl: 'Liberia', iso: 'LR', countryCode: 231 },
	{ en: 'Libya', pl: 'Libia', iso: 'LY', countryCode: 218 },
	{ en: 'Liechtenstein', pl: 'Liechtenstein', iso: 'LI', countryCode: 423 },
	{ en: 'Lithuania', pl: 'Litwa', iso: 'LT', countryCode: 370 },
	{ en: 'Luxembourg', pl: 'Luksemburg', iso: 'LU', countryCode: 352 },
	{ en: 'Madagascar', pl: 'Madagaskar', iso: 'MG', countryCode: 261 },
	{ en: 'Malawi', pl: 'Malawi', iso: 'MW', countryCode: 265 },
	{ en: 'Malaysia', pl: 'Malezja', iso: 'MY', countryCode: 60 },
	{ en: 'Maldives', pl: 'Malediwy', iso: 'MV', countryCode: 960 },
	{ en: 'Mali', pl: 'Mali', iso: 'ML', countryCode: 223 },
	{ en: 'Malta', pl: 'Malta', iso: 'MT', countryCode: 356 },
	{ en: 'Marshall Islands', pl: 'Wyspy Marshalla', iso: 'MH', countryCode: 692 },
	{ en: 'Mauritania', pl: 'Mauretania', iso: 'MR', countryCode: 222 },
	{ en: 'Mauritius', pl: 'Mauritius', iso: 'MU', countryCode: 230 },
	{ en: 'Mexico', pl: 'Meksyk', iso: 'MX', countryCode: 52 },
	{ en: 'Federated States of Micronesia', pl: 'Mikronezja', iso: 'FM', countryCode: 691 },
	{ en: 'Moldova', pl: 'Mołdawia', iso: 'MD', countryCode: 373 },
	{ en: 'Monaco', pl: 'Monako', iso: 'MC', countryCode: 377 },
	{ en: 'Mongolia', pl: 'Mongolia', iso: 'MN', countryCode: 976 },
	{ en: 'Montenegro', pl: 'Czarnogóra', iso: 'ME', countryCode: 382 },
	{ en: 'Morocco', pl: 'Maroko', iso: 'MA', countryCode: 212 },
	{ en: 'Mozambique', pl: 'Mozambik', iso: 'MZ', countryCode: 258 },
	{ en: 'Myanmar', pl: 'Mjanma', iso: 'MM', countryCode: 95 },
	{ en: 'Namibia', pl: 'Namibia', iso: 'NA', countryCode: 264 },
	{ en: 'Nauru', pl: 'Nauru', iso: 'NR', countryCode: 674 },
	{ en: 'Nepal', pl: 'Nepal', iso: 'NP', countryCode: 977 },
	{ en: 'Netherlands', pl: 'Holandia', iso: 'NL', countryCode: 31 },
	{ en: 'New Zealand', pl: 'Nowa Zelandia', iso: 'NZ', countryCode: 64 },
	{ en: 'Nicaragua', pl: 'Nikaragua', iso: 'NI', countryCode: 505 },
	{ en: 'Niger', pl: 'Niger', iso: 'NE', countryCode: 227 },
	{ en: 'Nigeria', pl: 'Nigeria', iso: 'NG', countryCode: 234 },
	{ en: 'North Macedonia', pl: 'Macedonia Północna', iso: 'MK', countryCode: 389 },
	{ en: 'Norway', pl: 'Norwegia', iso: 'NO', countryCode: 47 },
	{ en: 'Oman', pl: 'Oman', iso: 'OM', countryCode: 968 },
	{ en: 'Pakistan', pl: 'Pakistan', iso: 'PK', countryCode: 92 },
	{ en: 'Palau', pl: 'Palau', iso: 'PW', countryCode: 680 },
	{ en: 'Panama', pl: 'Panama', iso: 'PA', countryCode: 507 },
	{ en: 'Papua New Guinea', pl: 'Papua-Nowa Gwinea', iso: 'PG', countryCode: 675 },
	{ en: 'Paraguay', pl: 'Paragwaj', iso: 'PY', countryCode: 595 },
	{ en: 'Peru', pl: 'Peru', iso: 'PE', countryCode: 51 },
	{ en: 'Philippines', pl: 'Filipiny', iso: 'PH', countryCode: 63 },
	{ en: 'Portugal', pl: 'Portugalia', iso: 'PT', countryCode: 351 },
	{ en: 'Qatar', pl: 'Katar', iso: 'QA', countryCode: 974 },
	{ en: 'Romania', pl: 'Rumunia', iso: 'RO', countryCode: 40 },
	{ en: 'Russia', pl: 'Rosja', iso: 'RU', countryCode: 7 },
	{ en: 'Rwanda', pl: 'Rwanda', iso: 'RW', countryCode: 250 },
	{ en: 'Saint Kitts and Nevis', pl: 'Saint Kitts i Nevis', iso: 'KN', countryCode: 1 },
	{ en: 'Saint Lucia', pl: 'Saint Lucia', iso: 'LC', countryCode: 1 },
	{ en: 'Saint Vincent and the Grenadines', pl: 'Saint Vincent i Grenadyny', iso: 'VC', countryCode: 1 },
	{ en: 'Samoa', pl: 'Samoa', iso: 'WS', countryCode: 1 },
	{ en: 'San Marino', pl: 'San Marino', iso: 'SM', countryCode: 378 },
	{ en: 'Sao Tome and Principe', pl: 'Wyspy Świętego Tomasza i Książęca', iso: 'ST', countryCode: 239 },
	{ en: 'Saudi Arabia', pl: 'Arabia Saudyjska', iso: 'SA', countryCode: 966 },
	{ en: 'Senegal', pl: 'Senegal', iso: 'SN', countryCode: 221 },
	{ en: 'Serbia', pl: 'Serbia', iso: 'RS', countryCode: 381 },
	{ en: 'Seychelles', pl: 'Seszele', iso: 'SC', countryCode: 248 },
	{ en: 'Sierra Leone', pl: 'Sierra Leone', iso: 'SL', countryCode: 232 },
	{ en: 'Singapore', pl: 'Singapur', iso: 'SG', countryCode: 65 },
	{ en: 'Slovakia', pl: 'Słowacja', iso: 'SK', countryCode: 421 },
	{ en: 'Slovenia', pl: 'Słowenia', iso: 'SI', countryCode: 386 },
	{ en: 'Solomon Islands', pl: 'Wyspy Salomona', iso: 'SB', countryCode: 677 },
	{ en: 'Somalia', pl: 'Somali', iso: 'SO', countryCode: 252 },
	{ en: 'South Africa', pl: 'Afryka Południowa', iso: 'ZA', countryCode: 27 },
	{ en: 'Spain', pl: 'Hiszpania', iso: 'ES', countryCode: 34 },
	{ en: 'Sri Lanka', pl: 'Sri Lanka', iso: 'LK', countryCode: 94 },
	{ en: 'Sudan', pl: 'Sudan', iso: 'SD', countryCode: 249 },
	{ en: 'South Sudan', pl: 'Sudan Południowy', iso: 'SS', countryCode: 211 },
	{ en: 'Suriname', pl: 'Surinam', iso: 'SR', countryCode: 597 },
	{ en: 'Sweden', pl: 'Szwecja', iso: 'SE', countryCode: 46 },
	{ en: 'Switzerland', pl: 'Szwajcaria', iso: 'CH', countryCode: 41 },
	{ en: 'Syria', pl: 'Syria', iso: 'SY', countryCode: 963 },
	{ en: 'Taiwan', pl: 'Tajwan', iso: 'TW', countryCode: 886 },
	{ en: 'Tajikistan', pl: 'Tadżykistan', iso: 'TJ', countryCode: 992 },
	{ en: 'Tanzania, United Republic of', pl: 'Tanzania, Zjednoczona Republika', iso: 'TZ', countryCode: 255 },
	{ en: 'Thailand', pl: 'Tajlandia', iso: 'TH', countryCode: 66 },
	{ en: 'Togo', pl: 'Togo', iso: 'TG', countryCode: 228 },
	{ en: 'Tonga', pl: 'Tonga', iso: 'TO', countryCode: 676 },
	{ en: 'Trinidad and Tobago', pl: 'Trynidad i Tobago', iso: 'TT', countryCode: 1 },
	{ en: 'Tunisia', pl: 'Tunezja', iso: 'TN', countryCode: 216 },
	{ en: 'Turkey', pl: 'Turcja', iso: 'TR', countryCode: 90 },
	{ en: 'Turkmenistan', pl: 'Turkmenia', iso: 'TM', countryCode: 993 },
	{ en: 'Tuvalu', pl: 'Tuvalu', iso: 'TV', countryCode: 688 },
	{ en: 'Uganda', pl: 'Uganda', iso: 'UG', countryCode: 256 },
	{ en: 'Ukraine', pl: 'Ukraina', iso: 'UA', countryCode: 380 },
	{ en: 'United Arab Emirates', pl: 'Zjednoczone Emiraty Arabskie', iso: 'AE', countryCode: 971 },
	{ en: 'United Kingdom', pl: 'Wielka Brytania', iso: 'GB', countryCode: 44 },
	{ en: 'United States', pl: 'Stany Zjednoczone', iso: 'US', countryCode: 1 },
	{ en: 'Uruguay', pl: 'Urugwaj', iso: 'UY', countryCode: 598 },
	{ en: 'Uzbekistan', pl: 'Uzbekistan', iso: 'UZ', countryCode: 998 },
	{ en: 'Vanuatu', pl: 'Vanuatu', iso: 'VU', countryCode: 678 },
	{ en: 'Vatican City', pl: 'Watykan', iso: 'VA', countryCode: 379 },
	{ en: 'Venezuela', pl: 'Wenezuela', iso: 'VE', countryCode: 58 },
	{ en: 'Vietnam', pl: 'Wietnam', iso: 'VN', countryCode: 84 },
	{ en: 'Yemen', pl: 'Jemen', iso: 'YE', countryCode: 967 },
	{ en: 'Zambia', pl: 'Zambia', iso: 'ZM', countryCode: 260 },
	{ en: 'Zimbabwe', pl: 'Zimbabwe', iso: 'ZW', countryCode: 263 },
];
